import * as types from '../actions/actionTypes'

const initialState = {
  jwt: localStorage.jwt,
  userStatus: localStorage.getItem('userStatus') || 'unauthorized',
  currentUser: {},
  activationCode: sessionStorage.getItem('activationCode') || null
}

export default function sessionReducer(state = initialState, action) {
  switch (action.type) {
    case types.SMS_SENT:
      return {
        ...state,
        userStatus: action.userStatus
      }
    case types.LOG_OUT:
      return {
        ...initialState,
        jwt: null,
        userStatus: null
      }
    case types.ACTIVATE_CODE:
      return {
        ...state,
        jwt: action.jwt
      }
    case types.REGISTERED:
      return {
        ...state,
        userStatus: action.userStatus
      }
    case types.SET_USER_STATUS:
      return {
        ...state,
        userStatus: action.status
      }
    case types.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.currentUser
      }
    case types.SET_ACTIVATION_CODE:
      return {
        ...state,
        activationCode: action.code
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sessionReducer.js